import React from 'react';

import ActivitySetupStepNotification from '../../components/Setup/StepNotification';


function ActivitySetupStepNotificationView() {
  return (
    <ActivitySetupStepNotification />
  );
}

export default ActivitySetupStepNotificationView;
